import { Toaster as Sonner, ToasterProps } from "sonner";
import { useKonami } from "@/context/KonamiContext";

const Toaster = ({ ...props }: ToasterProps) => {
  const { konamiMode } = useKonami();

  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="top-center"
      expand={true}
      richColors={false}
      closeButton={true}
      icons={{
        success: undefined,
        error: undefined,
        warning: undefined,
        info: undefined,
        loading: undefined,
      }}
      toastOptions={{
        style: konamiMode
          ? {
              // TRON Theme
              background: "rgba(10, 10, 10, 0.95)",
              border: "1px solid rgba(0, 255, 255, 0.3)",
              color: "#00FFFF",
              fontFamily:
                'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace',
              fontSize: "14px",
              backdropFilter: "blur(12px)",
              boxShadow: "0 0 15px rgba(0, 255, 255, 0.2), 0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
            }
          : {
              // Matrix Theme
              background: "rgba(0, 0, 0, 0.95)",
              border: "1px solid rgba(34, 197, 94, 0.3)",
              color: "#22C55E",
              fontFamily:
                'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace',
              fontSize: "14px",
              backdropFilter: "blur(12px)",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              borderRadius: "8px",
            },
        className: konamiMode ? "terminal-toast-tron" : "terminal-toast-matrix",
        unstyled: false,
      }}
      {...props}
    />
  );
};

export { Toaster };
